<template>
  <div id="centro-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE AVANCE -->
              <v-card
                :key="cardAvance"
                flat
                v-if="tabSelected == 'Registro Avances'"
              >
                <avance-revision-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></avance-revision-tab>
              </v-card>
              <!-- TAB DE EVOLUCION -->
              <v-card
                :key="cardEvolucion"
                flat
                v-if="tabSelected == 'Evolucion'"
              >
                <evolucion-revision-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></evolucion-revision-tab>
              </v-card>
              <!-- TAB DE PORCENTAJE AVANCE -->
              <!-- <v-card :key="cardPorcentajeAvance" flat v-if="tabSelected=='Prorcentaje Avance'"> -->
              <v-card
                :key="cardEvolucion"
                flat
                v-if="tabSelected == 'Porcentaje Avance'"
              >
                <!-- <evolucion-revision-tab :show="true" :tipeView="'modifica'" :contratoId="contratoId"></evolucion-revision-tab> -->
                <porcentaje-avance-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></porcentaje-avance-tab>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AvanceRevisionTab from "@/modules/aplicacion/views/revision/Revision.vue";
import EvolucionRevisionTab from "@/modules/aplicacion/views/revision/Revision.vue";
import PorcentajeAvanceTab from "@/modules/aplicacion/views/revision/PorcentajeAvanceTab.vue";

export default {
  name: "revision-sub-tab",

  components: {
    AvanceRevisionTab,
    EvolucionRevisionTab,
    PorcentajeAvanceTab,
  },
  props: {},
  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: ["Registro Avances", "Evolucion", "Porcentaje Avance"],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",

    cardAvance: 0,
    cardEvolucion: 10,
    cardPorcentajeAvance: 20,
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
      if (this.tabSelected == "Registro Avances") {
        this.reloadRegistroAvance();
      }
      if (this.tabSelected == "Evolucion") {
        this.reloadEvolucion();
      }
      if (this.tabSelected == "Porcentaje Avance") {
        this.reloadPorcentajeAvance();
      }
    },
    reloadRegistroAvance() {
      this.cardAvance += 1;
    },

    reloadEvolucion() {
      this.cardEvolucion += 11;
    },

    reloadPorcentajeAvance() {
      this.cardPorcentajeAvance += 21;
    },
  },
};
</script>
